import commonApi from './CommonApi.js';

export default {
	getList: async (parameters) => {
		return await commonApi().get('/entityMetadatas', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
				if (error.response.data.status === 400) {
					return error.response.data;
				}
				else {
					console.log(error.response);
				}
			});
	},
	save: async (viewModel) => {
		return await commonApi().post('/entityMetadatas', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}